import { cn } from '@/lib/cn';
import { useUiStore } from '@/stores/ui.store';

/**
 * Toast outlet. Mounted once by the app shell; anything can push to it via
 * the ui store without prop-drilling a handler.
 */
export function Toaster() {
  const toasts = useUiStore((s) => s.toasts);
  const dismiss = useUiStore((s) => s.dismiss);

  if (toasts.length === 0) return null;

  return (
    <div
      // Announced politely so a squad change is read out without interrupting.
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed bottom-24 right-4 z-200 flex flex-col items-end gap-2 sm:bottom-6 sm:right-6"
    >
      {toasts.map((toast) => (
        <button
          key={toast.id}
          type="button"
          onClick={() => dismiss(toast.id)}
          className={cn(
            'pointer-events-auto max-w-sm rounded-control px-4 py-2.5 text-left text-[11px] font-extrabold shadow-[0_10px_25px_rgba(0,0,0,0.35)] transition',
            'motion-safe:animate-[toast-in_0.25s_cubic-bezier(0.175,0.885,0.32,1.275)]',
            toast.tone === 'error' ? 'bg-danger text-on-danger' : 'bg-content text-on-content',
          )}
        >
          {toast.tone === 'error' ? '! ' : '✓ '}
          {toast.message}
        </button>
      ))}
    </div>
  );
}
